<template>
    <div class="noticeContent">
        <!-- 面包屑 -->
        <div class="crumbs">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>更多公告</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="noticeBox">
            <div class="noticeTop">平台公告</div>
            <div class="notice" v-for="(item,index) in noticeList.list" :key="index" @click="noticeTap(item.id)">
                <div class="noticeTitle">{{ item.title }}</div>
                <div class="noticeTime">{{ item.create_time }}</div>
            </div>
            <div class="pageBox">
                <el-pagination background layout="prev, pager, next" :page-size="20" :total="noticeList.count" @current-change="currentPage"></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
    export default{
        data(){
            return{
                page: 1,
                noticeList: {}
            }
        },
        mounted(){
            this.getNoticelist()
        },
        methods: {
            // 获取公告列表
            getNoticelist(){
                this.request.get("index/index/noticelist",{
                    params:{
                        page: this.page,
                        pagesize: '20'
                    }
                })
                .then(res=>{
                    this.noticeList = res.data
                })
            },
            // 翻页
            currentPage(e){
                this.page = e
                this.getNoticelist()
            },
            // 跳转公告详情
            noticeTap(e){
                this.$router.push({ path:'/notice/noticeDetail', query:{id: e} })
            }
        }
    }
</script>
<style lang="less" scoped>
    .noticeContent{
        background: #FAFBFC;
        padding-bottom: 50px;
        .noticeBox{
            width: 972px;
            padding: 0 221px 50px 35px;
            background: #FFFFFF;
            border-radius: 10px;
            margin: 0 auto;
            .noticeTop{
                font: 26px/26px "Microsoft YaHei";
                color: #464646;
                border-bottom: 1px solid #E6E7EB;
                padding: 40px 0 34px 0;
            }
            .notice{
                padding: 28px 0 10px 0;
                cursor: pointer;
                .noticeTitle{
                    font: 16px/16px "Microsoft YaHei";
                    color: #464646;
                }
                .noticeTime{
                    font: 14px/14px "Microsoft YaHei";
                    color: #BABDC7;
                    padding-top: 15px;
                }
            }
        }
    }
</style>